import React, { createRef } from 'react'
import ReactDOMServer from 'react-dom/server'
import ReactQuill from 'react-quill' // ES6
import { Icon } from 'antd'
import richTextIcons from './../../../../constants/rich-text-editor-icons'
import './../../ui.style.scss'
import 'react-quill/dist/quill.snow.css'
import PopoverConfirm from '../../feedback/PopoverConfirm'
import { cloneDeep, isEmpty } from 'lodash'
import './RichText.scss'
import { SketchPicker } from 'react-color'
const Quill = ReactQuill.Quill
const Size = Quill.import('attributors/style/size')
const fontSizes = [
  '6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '32px', '40px', '48px'
]
Size.whitelist = fontSizes
Quill.register(Size, true)

const icons = ReactQuill.Quill.import('ui/icons')

icons['header']['0'] = ReactDOMServer.renderToString(<Icon type='down' />)
icons['header']['1'] = ReactDOMServer.renderToString(<Icon type='down' />)
icons['header']['default'] = ReactDOMServer.renderToString(<Icon type='down' />)
icons['header']['active'] = ReactDOMServer.renderToString(<Icon type='down' />)
icons['header']['label'] = ReactDOMServer.renderToString(<Icon type='down' />)
icons['undo'] = richTextIcons.undoIcon
icons['redo'] = richTextIcons.redoIcon
icons['bold'] = richTextIcons.boldIcon
icons['italic'] = richTextIcons.italicsIcon
icons['underline'] = richTextIcons.underlineIcon
icons['strike'] = richTextIcons.strikeIcon
icons['list']['ordered'] = richTextIcons.orderedListIcon
icons['list']['bullet'] = richTextIcons.unOrderedListIcon
icons['blockquote'] = richTextIcons.blockQuoteIcon
icons['align'][''] = richTextIcons.leftAlignIcon
icons['align']['center'] = richTextIcons.centerAlignIcon
icons['align']['right'] = richTextIcons.rightAlignIcon
icons['align']['justify'] = richTextIcons.justifyIcon
icons['link'] = richTextIcons.linkIcon

function undo () {
  this.quill.history.undo()
}

function redo () {
  this.quill.history.redo()
}

const options = [
  { value: 1, displayValue: 'H1' },
  { value: 2, displayValue: 'H2' },
  { value: 3, displayValue: 'H3' },
  { value: 4, displayValue: 'H4' },
  { value: 5, displayValue: 'H5' },
  { value: 6, displayValue: 'H6' },
  { value: '', displayValue: 'Paragraph' }
]

const dropDown = (
  <select className='ql-header' defaultValue={''}>
    {options.map((option, index) => (
      <option key={`option${index}`} value={option.value}>
        {option.displayValue}
      </option>
    ))}
  </select>
)

const DEFAULT_COLORS = [
  '#222222',
  '#172659',
  '#05CEDD',
  '#0F676E',
  '#00a3ad',
  '#FF015A',
  '#fafafa',
  '#108ee9'
]

const filterMatcher = (node, delta) => {
  const deltaOps = cloneDeep(delta.ops).map(item => {
    if (item.insert && typeof item.insert === 'string') {
      // if (item.attributes) {
      //   delete item.attributes.color
      //   delete item.attributes.background
      // }
      if (typeof item.insert === 'string' && item.insert.length > 16) {
        while (true) {
          const isScriptStartTag = item.insert.indexOf('<script')
          const isScriptEndTag = item.insert.indexOf('</script>')
          if (isScriptStartTag > -1 && isScriptEndTag > -1) {
            item.insert = `${item.insert.substring(0, isScriptStartTag)}`
            item.insert = `${item.insert.substring(isScriptEndTag + 9, item.insert.length)}`
          } else {
            break
          }
        }
      }
      return item
    }
  })
  delta.ops = deltaOps
  return delta
}
const parentCompoent = 'asset-container'
class RichText extends React.Component {
  constructor (props) {
    super(props)
    this.ReactQuillRef = createRef()
    this.state = {
      colors: '',
      isFontColorPickerShown: false,
      isBackgroundColorPickerShown: false,
      isRichTextDirty: false
    }
  }
  CustomToolbar = () => {
    const { isFontColorPickerShown, isBackgroundColorPickerShown, colors } = this.state
    const { id } = this.props
    return (
      <div className='toolbar' id={`toolbar${id}`}>
        {dropDown}
        <button className='ql-undo'>UN</button>
        <button className='ql-redo'>RE</button>
        <button className='ql-bold' />
        <button className='ql-italic' />
        <button className='ql-underline' />
        <button className='ql-strike' />
        <button className='ql-list' value='bullet' />
        <button className='ql-list' value='ordered' />
        <button className='ql-blockquote' />
        <button className='ql-align' />
        <button className='ql-align' value='right' />
        <button className='ql-align' value='center' />
        <button className='ql-align' value='justify' />
        <button className='ql-link' />
        {/* New subscript and superscript buttons */}
        <button className='ql-script' value='sub' />
        <button className='ql-script' value='super' />
        {/* color picker options */}
        <div id={this.getColorPickerContainerId(id)} className='color-picker-container'>
          <div className='font-color-icon'>
            <span
              onClick={() => {
                const quillInstance = this.ReactQuillRef.current.getEditor()
                const selection = quillInstance.getSelection()
                const colorFromSelection = quillInstance.getFormat(selection)
                this.toggleFontColorChanger(!isFontColorPickerShown)
                this.toggleBackgroundColorChanger(false)
                let state = { selection }
                if (!isEmpty(colorFromSelection?.color)) {
                  state = {
                    ...state,
                    colors: {
                      hex: colorFromSelection?.color
                    }
                  }
                }
                this.setState(state)
              }}>
              <FontColorIcon />
            </span>
            {isFontColorPickerShown && (
              <div className='custom-color-picker font-color-icon-picker'>
                <SketchPicker
                  onChangeComplete={this.handleFontColorChange}
                  presetColors={DEFAULT_COLORS}
                  color={this.state.colors?.hex}
                  triangle='left'
                  className='font-color-picker'
                  disableAlpha
                />
                <button
                  onClick={() => {
                    const { selection } = this.state
                    const quillInstance = this.ReactQuillRef.current.getEditor()
                    quillInstance.formatText(selection.index, selection.length, 'color', colors.hex)
                    const innerContent = quillInstance.root.innerHTML
                    this.toggleFontColorChanger(false)
                    this.props.onRichTextChange(innerContent)
                    this.setState({ selection: null })
                  }}
                >
                  OK
                </button>
              </div>
            )}
          </div>
          <div className='background-color-icon'>
            <span
              onClick={() => {
                const quillInstance = this.ReactQuillRef.current.getEditor()
                const selection = quillInstance.getSelection()
                this.toggleBackgroundColorChanger(!isBackgroundColorPickerShown)
                this.toggleFontColorChanger(false)
                const colorFromSelection = quillInstance.getFormat(selection)
                let state = { selection }
                if (!isEmpty(colorFromSelection?.background)) {
                  state = {
                    ...state,
                    colors: {
                      hex: colorFromSelection?.background
                    }
                  }
                }
                this.setState(state)
              }}>
              <BackGroundColorIcon />
            </span>
            {isBackgroundColorPickerShown && (
              <div className='custom-color-picker background-color-icon-picker'>
                <SketchPicker
                  onChangeComplete={this.handleBackGroundColorChange}
                  presetColors={DEFAULT_COLORS}
                  color={this.state.colors?.hex}
                  triangle='left'
                  className='background-color-picker'
                  disableAlpha
                />
                <button
                  onClick={() => {
                    const { selection } = this.state
                    const quillInstance = this.ReactQuillRef.current.getEditor()
                    quillInstance.formatText(selection.index, selection.length, 'background', colors.hex)
                    const innerContent = quillInstance.root.innerHTML
                    this.toggleBackgroundColorChanger(false)
                    this.props.onRichTextChange(innerContent)
                    this.setState({ selection: null })
                  }}
                >
                  OK
                </button>
              </div>
            )}
          </div>
        </div>
        {/* font size dropdown */}
        <select className='ql-size'>
          <option value=''>Default</option>
          {
            fontSizes.map(item => {
              return (
                <option value={item}>{item}</option>
              )
            })
          }
        </select>
        {/* clear formatting */}
        <button className='ql-clean' />
      </div>
    )
  }

  getModule = id => {
    return {
      toolbar: {
        container: `#toolbar${id}`,
        handlers: {
          undo: undo,
          redo: redo
        }
      },
      clipboard: {
        matchers: [[Node.ELEMENT_NODE, filterMatcher]]
      },
      keyboard: {
        bindings: this.bindings
      }
    }
  }

  getBasicModule = id => {
    return {
      toolbar: false,
      clipboard: {
        matchers: [[Node.ELEMENT_NODE, filterMatcher]]
      },
      keyboard: {
        bindings: this.bindings
      }
    }
  }

  bindings = {
    alignLeft: {
      key: 'l',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-align`)
        btnClick.click()
      }
    },
    alignRight: {
      key: 'r',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-align[value='right']`)
        btnClick.click()
      }
    },
    alignCenter: {
      key: 'c',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-align[value='center']`)
        btnClick.click()
      }
    },
    alignJustify: {
      key: 'j',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-align[value='justify']`)
        btnClick.click()
      }
    },
    blockQuote: {
      key: 'q',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-blockquote`)
        btnClick.click()
      }
    },
    unList: {
      key: 'u',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-list`)
        btnClick.click()
      }
    },
    orderList: {
      key: 'o',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-list`)
        btnClick.click()
      }
    },
    strike: {
      key: 'd',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-strike`)
        btnClick.click()
      }
    },
    link: {
      key: 'a',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(`#toolbar${this.props.id} .ql-link`)
        btnClick.click()
      }
    },
    paragraph: {
      key: '0',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(7)`
        )
        btnClick.click()
      }
    },
    h1: {
      key: '1',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:first-child`
        )
        btnClick.click()
      }
    },
    h2: {
      key: '2',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(2)`
        )
        btnClick.click()
      }
    },
    h3: {
      key: '3',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(3)`
        )
        btnClick.click()
      }
    },
    h4: {
      key: '4',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(4)`
        )
        btnClick.click()
      }
    },
    h5: {
      key: '5',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(5)`
        )
        btnClick.click()
      }
    },
    h6: {
      key: '6',
      altKey: true,
      shiftKey: true,
      handler: () => {
        let btnClick = document.querySelector(
          `#toolbar${this.props.id} .ql-picker-options .ql-picker-item:nth-child(6)`
        )
        btnClick.click()
      }
    }
  }

  onRichTextChange = (data, delta, source) => {
    if (source === 'user' && data === '<p><br></p>') {
      this.props.onRichTextChange(null)
    } else if (source === 'user') {
      this.props.onRichTextChange(data)
    }
  }

  toggleFontColorChanger = flag => {
    this.setState({
      isFontColorPickerShown: flag
    })
  }
  handleFontColorChange = colors => {
    this.setState({
      colors
    })
  }

  toggleBackgroundColorChanger = flag => {
    this.setState({
      isBackgroundColorPickerShown: flag
    })
  }
  handleBackGroundColorChange = colors => {
    this.setState({
      colors
    })
  }

  // close font color and background color picker when clicked outside
  handleOutsideClick = event => {
    const { isBackgroundColorPickerShown, isFontColorPickerShown } = this.state
    const colorPickerContainer = document.getElementById(this.getColorPickerContainerId(this.props.id))
    const isAnyColorPickerOpen = isBackgroundColorPickerShown || isFontColorPickerShown
    const clickedElementIsOutside = !colorPickerContainer?.contains(event.target)
    if (clickedElementIsOutside && isAnyColorPickerOpen) {
      this.toggleBackgroundColorChanger(false)
      this.toggleFontColorChanger(false)
    }
  }

  componentDidMount () {
    const colorPickerContainer = document.getElementById(this.getColorPickerContainerId(this.props.id))
    if (!isEmpty(colorPickerContainer)) {
      document.addEventListener('click', this.handleOutsideClick)
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  getEditorId = id => `${id}-rich-text-editor`
  getColorPickerContainerId = id => `${id}-color-picker-container`

  render () {
    const {
      id,
      onCloseContent,
      onInputFieldFocus,
      onInputFieldBlur,
      text,
      showCloseIcon,
      readOnly,
      showToolbar,
      wrapperClassName = '',
      onWrapperClick = () => null
    } = this.props
    return (
      <pre
        id={this.getEditorId(id)}
        className={`${wrapperClassName} rich-text-editor-wrapper text-editor`}
        onClick={onWrapperClick}>
        {showCloseIcon ? (
          <PopoverConfirm confirm={onCloseContent} parentCompoent={parentCompoent} />
        ) : null}
        {showToolbar === false ? null : <this.CustomToolbar />}
        <ReactQuill
          ref={this.ReactQuillRef}
          onChange={this.onRichTextChange}
          onFocus={onInputFieldFocus}
          onBlur={onInputFieldBlur}
          placeholder=''
          modules={
            showToolbar === undefined || showToolbar === null || showToolbar === true
              ? this.getModule(id)
              : showToolbar === false
                ? this.getBasicModule(id)
                : null
          }
          value={text}
          bounds={'.text-editor'}
          readOnly={readOnly}
        />
        {/* {console.log('raw')}
        {console.log(text)} */}
      </pre>
    )
  }
}

export default RichText

const FontColorIcon = () => (
  <span class='ql-color ql-picker ql-color-picker'>
    <span
      class='ql-picker-label'
      tabindex='0'
      role='button'
      aria-expanded='false'
      aria-controls='ql-picker-options-1'
      data-value='color-picker'>
      <svg viewBox='0 0 18 18'>
        {' '}
        <line class='ql-color-label ql-stroke ql-transparent' x1='3' x2='15' y1='15' y2='15' />{' '}
        <polyline class='ql-stroke' points='5.5 11 9 3 12.5 11' />{' '}
        <line class='ql-stroke' x1='11.63' x2='6.38' y1='9' y2='9' />{' '}
      </svg>
    </span>
    <span class='ql-picker-options' aria-hidden='true' tabindex='-1' id='ql-picker-options-1'>
      <span
        tabindex='0'
        role='button'
        class='ql-picker-item ql-primary'
        data-value='color-picker'
      />
    </span>
  </span>
)

const BackGroundColorIcon = () => (
  <span class='ql-background ql-picker ql-color-picker'>
    <span
      class='ql-picker-label'
      tabindex='0'
      role='button'
      aria-expanded='false'
      aria-controls='ql-picker-options-2'
      data-value='color-picker'>
      <svg viewBox='0 0 18 18'>
        {' '}
        <g class='ql-fill ql-color-label'>
          {' '}
          <polygon points='6 6.868 6 6 5 6 5 7 5.942 7 6 6.868' />{' '}
          <rect height='1' width='1' x='4' y='4' />{' '}
          <polygon points='6.817 5 6 5 6 6 6.38 6 6.817 5' />{' '}
          <rect height='1' width='1' x='2' y='6' /> <rect height='1' width='1' x='3' y='5' />{' '}
          <rect height='1' width='1' x='4' y='7' />{' '}
          <polygon points='4 11.439 4 11 3 11 3 12 3.755 12 4 11.439' />{' '}
          <rect height='1' width='1' x='2' y='12' /> <rect height='1' width='1' x='2' y='9' />{' '}
          <rect height='1' width='1' x='2' y='15' />{' '}
          <polygon points='4.63 10 4 10 4 11 4.192 11 4.63 10' />{' '}
          <rect height='1' width='1' x='3' y='8' />{' '}
          <path d='M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z' />{' '}
          <path d='M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z' />{' '}
          <path d='M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z' />{' '}
          <rect height='1' width='1' x='12' y='2' /> <rect height='1' width='1' x='11' y='3' />{' '}
          <path d='M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z' /> <rect height='1' width='1' x='2' y='3' />{' '}
          <rect height='1' width='1' x='6' y='2' /> <rect height='1' width='1' x='3' y='2' />{' '}
          <rect height='1' width='1' x='5' y='3' /> <rect height='1' width='1' x='9' y='2' />{' '}
          <rect height='1' width='1' x='15' y='14' />{' '}
          <polygon points='13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174' />{' '}
          <rect height='1' width='1' x='13' y='7' /> <rect height='1' width='1' x='15' y='5' />{' '}
          <rect height='1' width='1' x='14' y='6' /> <rect height='1' width='1' x='15' y='8' />{' '}
          <rect height='1' width='1' x='14' y='9' />{' '}
          <path d='M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z' />{' '}
          <rect height='1' width='1' x='14' y='3' />{' '}
          <polygon points='12 6.868 12 6 11.62 6 12 6.868' />{' '}
          <rect height='1' width='1' x='15' y='2' /> <rect height='1' width='1' x='12' y='5' />{' '}
          <rect height='1' width='1' x='13' y='4' />{' '}
          <polygon points='12.933 9 13 9 13 8 12.495 8 12.933 9' />{' '}
          <rect height='1' width='1' x='9' y='14' /> <rect height='1' width='1' x='8' y='15' />{' '}
          <path d='M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z' />{' '}
          <rect height='1' width='1' x='5' y='15' />{' '}
          <path d='M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z' />{' '}
          <rect height='1' width='1' x='11' y='15' />{' '}
          <path d='M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z' />{' '}
          <rect height='1' width='1' x='14' y='15' /> <rect height='1' width='1' x='15' y='11' />{' '}
        </g>{' '}
        <polyline class='ql-stroke' points='5.5 13 9 5 12.5 13' />{' '}
        <line class='ql-stroke' x1='11.63' x2='6.38' y1='11' y2='11' />{' '}
      </svg>
    </span>
    <span class='ql-picker-options' aria-hidden='true' tabindex='-1' id='ql-picker-options-2'>
      <span
        tabindex='0'
        role='button'
        class='ql-picker-item ql-primary'
        data-value='color-picker'
      />
    </span>
  </span>
)
